<script setup lang="ts">
import LazyImage from '@/vue/atoms/lazy-image.vue';

defineProps<{
  companyImage?: string | null;
}>();
</script>

<template>
  <lazy-image
    v-if="companyImage"
    :src="companyImage"
    :width="120"
    format="webp"
    skip-loader
    alt-txt=""
    aria-hidden="true"
    class="company-badge"
  />
</template>

<style lang="scss" scoped>
.company-badge {
  position: absolute;
  top: 0;
  right: 0;
  width: clamp(60px, 12%, 120px);
  height: auto;
  pointer-events: none;
}
</style>
